export const middlewareConfirmedInvitations = (data: any): IMatchmakingInvitation[] =>
  data?.map((item: any) => {
    const progressProposed = item?.Progress?.find((item: IProgress) => item?.action === 'proposed');

    return {
      matchId: item?.match_id || '',
      professionalId: item?.ProfessionalId || '',
      eventSlug: item?.EventTitle || '',
      fullname: `${item?.Name} ${item?.Lastname}` || '',
      name: item?.Name || '',
      lastname: item?.Lastname || '',
      companyName: item?.Company || '',
      avatar: item?.Avatar || '',
      owner: item?.Owner || false,
      date: item?.Date || progressProposed?.match_history_date?.date || '',
      eventType: item?.EventType || '',
      scheduleEnd: item.ScheduleEnd || '',
      table: item?.event_subscribe?.additional || '',
      date_id: progressProposed?.match_history_date?.id || '',
      message: progressProposed?.message || '',
      profissionalOwnerId: progressProposed?.professional_id || '',
    };
  });
